/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VoucherProduct
 */
export interface VoucherProduct {
    /**
     * 
     * @type {number}
     * @memberof VoucherProduct
     */
    voucherId?: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherProduct
     */
    productId?: number;
    /**
     * 
     * @type {Date}
     * @memberof VoucherProduct
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VoucherProduct
     */
    updatedAt?: Date;
}

export function VoucherProductFromJSON(json: any): VoucherProduct {
    return VoucherProductFromJSONTyped(json, false);
}

export function VoucherProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'voucherId': !exists(json, 'voucherId') ? undefined : json['voucherId'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function VoucherProductToJSON(value?: VoucherProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'voucherId': value.voucherId,
        'productId': value.productId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


